<footer class="footer">
  <div class="footer__container w-full max-w-full mx-auto box-border">
    <div class="footer__grid w-full min-w-0">
      <!-- Branding -->
      <div class="footer__column footer__column--brand flex flex-col gap-4 min-w-0">
        <a routerLink="/" class="footer__logo-link inline-flex shrink-0" aria-label="IUDX Health home">
          <img [src]="logoSrc" alt="IUDX Health" class="footer__logo-img object-contain" width="77" height="48" />
        </a>
        <h2 class="footer__brand-title m-0">{{ brandTitle }}</h2>
        <p class="footer__brand-desc m-0">{{ brandDescription }}</p>
        <a
          [href]="healthcarePortalUrl"
          class="footer__portal-link inline-flex items-center gap-2 min-w-0"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img [src]="globeIconSrc" alt="" class="footer__globe-icon shrink-0" width="20" height="20" />
          <span class="footer__portal-url truncate">{{ healthcarePortalUrl }}</span>
        </a>
      </div>

      <div class="footer__columns-trailing">
        <!-- Important links -->
        <nav class="footer__column footer__column--trailing min-w-0" aria-label="Important links">
          <h3 class="footer__heading">{{ importantLinksHeading }}</h3>
          <ul class="footer__list list-none m-0 p-0 flex flex-col gap-3">
            @for (link of importantLinks; track link.label) {
              <li>
                @if (link.label === 'Dashboard') {
                  <a href="#" class="footer__link" (click)="onDashboardClick($event)">{{ link.label }}</a>
                } @else if (link.external) {
                  <a [href]="link.url" class="footer__link" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
                } @else {
                  <a [routerLink]="link.url" class="footer__link">{{ link.label }}</a>
                }
              </li>
            }
          </ul>
        </nav>

        <!-- Developers -->
        <div class="footer__column footer__column--trailing min-w-0">
          <h3 class="footer__heading">{{ developersHeading }}</h3>
          <ul class="footer__list list-none m-0 p-0 flex flex-col gap-3">
            @for (link of developerLinks; track link.url) {
              <li>
                <a [href]="link.url" class="footer__link" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
              </li>
            }
          </ul>
          <a routerLink="/contact-us" class="footer__contact-btn inline-flex items-center justify-center mt-6">{{ contactUsLabel }}</a>
        </div>

        <!-- Partners -->
        <div class="footer__column footer__column--trailing min-w-0">
          <h3 class="footer__heading">{{ partnersHeading }}</h3>
          <div class="footer__partners flex flex-wrap items-center gap-6">
            @for (logo of partnerLogos; track logo.src) {
              @if (logo.url) {
                <a
                  [href]="logo.url"
                  class="footer__partner-link inline-flex items-center justify-center shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                  [attr.aria-label]="logo.name"
                >
                  <img
                    [src]="logo.src"
                    [alt]="logo.name"
                    class="footer__partner-img"
                    loading="lazy"
                    (error)="onLogoError($event)"
                  />
                </a>
              } @else {
                <span class="footer__partner-link inline-flex items-center justify-center shrink-0">
                  <img
                    [src]="logo.src"
                    [alt]="logo.name"
                    class="footer__partner-img"
                    loading="lazy"
                    (error)="onLogoError($event)"
                  />
                </span>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="footer__bottom w-full min-w-0">
      <p class="footer__copyright m-0">© {{ currentYear }} IUDX Healthcare</p>
      <div class="footer__legal">
        <a routerLink="/privacy-policy" class="footer__legal-link">{{ privacyLabel }}</a>
        <a routerLink="/terms-of-service" class="footer__legal-link">{{ termsLabel }}</a>
      </div>
    </div>
  </div>
</footer>
